"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.loadProductListingData = void 0;
var _fetching = require("@ori/fetching");
var _logger = require("../../../logger");
var _models = require("../../../models");
var _productListingPagePagination = require("../../../queries-net/productListingPagePagination");
/* istanbul ignore file @preserve */ const localLogger = _logger.mainLogger.createChild('loadProductListingData');
const loadProductListingData = async (param)=>{
    let { headers, orderBy, pageId, skip, graphQlUrl, limit, facetFiltering = [], previewMode } = param;
    try {
        return await (0, _fetching.fetchGraphql)({
            query: _productListingPagePagination.productListingQueryPagination,
            variables: {
                channelType: _models.EditorialChannelType.Web,
                limit,
                skip,
                pageId,
                orderBy,
                facetFiltering
            },
            url: graphQlUrl,
            headers: {
                ...headers,
                [_fetching.PREVIEW_MODE]: previewMode !== null && previewMode !== void 0 ? previewMode : false
            },
            ...previewMode ? {
                timeout: 30000
            } : null
        });
    } catch (error) {
        localLogger.error(new Error('fetchGraphql productListingQueryPagination', {
            cause: error
        }));
        throw error;
    }
};
exports.loadProductListingData = loadProductListingData;
